module.exports = __webpack_public_path__ + "img/1584527434.51fd5985.jpg";